const routes = [
    {
        path: "/countries",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "country_index"
        }
    }
];

export default routes;
